<template>
  <div class="skin-analysis-loading-bg">
    <div class="skin-analysis-loading-view">
      <div class="skin-analysis-loading-container-wrapper">
        <div class="skin-analysis-loading-container">
          <img
            src="../assets/images/skin_analysis_loading.png"
            class="skin-analysis-loading-img"
            alt="loading"
          />
          <div class="skin-analysis-loading-progress">
            {{ progress }}
          </div>
          <div class="skin-analysis-loading-percent">&#37;</div>
        </div>
      </div>
      <div class="skin-analysis-loading-trivia-container-wrapper">
        <div class="skin-analysis-loading-trivia-container">
          <div class="skin-analysis-trivia-title">
            {{ $t("trivia.title") }}
          </div>
          <div class="skin-analysis-trivia-content">
            {{ computeTrivia }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventLogUtil from "../utils/eventLogUtil";
import constant from "../const";

export default {
  props: {
    accountId: {
      type: String,
      required: false,
      default: undefined,
    },
    progress: {
      type: Number,
      required: true,
      default: 0,
    },
    triviaMaster: {
      type: Array,
      required: true,
    },
    allData: {
      type: Object,
      require: false,
      default: undefined,
    },
  },
  data() {
    return {
      machineIdList: [""],
    };
  },
  computed: {
    computeTrivia() {
      let targetMachineIdList = this.machineIdList;
      if (
        targetMachineIdList.includes("EH-SR86") &&
        targetMachineIdList.includes("EH-SR85")
      ) {
        targetMachineIdList = targetMachineIdList.filter(
          (id) => id !== "EH-SR85"
        );
      }

      let triviaList = [];
      this.triviaMaster.forEach((element) => {
        if (
          targetMachineIdList.includes(element.machineId) ||
          element.machineId === ""
        ) {
          triviaList = triviaList.concat(element.triviaList);
        }
      });

      const trivia = triviaList[Math.floor(Math.random() * triviaList.length)];
      return trivia.message;
    },
  },
  mounted() {
    if (this.allData) {
      const machineData = this.allData.machineDataList[0];
      if (machineData && machineData.machineIdList) {
        this.machineIdList = machineData.machineIdList;
      }
    }
    this.registerViewedPageEvent();
  },
  updated() {},
  methods: {
    // ページ表示のイベントログ登録
    registerViewedPageEvent() {
      if (
        this.accountId !== undefined &&
        this.accountId !== constant.GUEST_ACCOUNT_ID
      ) {
        const screenId =
          eventLogUtil.getScreenIdList().skinAnalysisBrowserAnalyzing;
        const eventData = {
          screenId,
          trivia: this.computeTrivia,
        };
        eventLogUtil.registerEvent(
          this.accountId,
          eventLogUtil.getEventCodeList().viewed_page,
          eventData
        );
      }
    },
  },
};
</script>

<style>
.skin-analysis-loading-bg {
  width: 100vw;
  min-height: 100svh;
  position: fixed; /* ブラウザの定位置に固定 */
  z-index: 999;
  background: white;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skin-analysis-loading-view {
  height: 100%;
  width: 100%;
  position: relative;
}

.skin-analysis-loading-container-wrapper {
  height: 136px;
  width: 136px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.skin-analysis-loading-container {
  height: 100%;
  width: 100%;
  position: relative;
}

.skin-analysis-loading-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.skin-analysis-loading-progress {
  position: absolute;
  bottom: 51px;
  right: 40px;
  transform: translate(0%, 0%);
  display: flex;
  justify-content: center; /* 中央寄せ */
  align-items: flex-end; /* 下寄せ */
  width: 66px;
  height: 44px;
  font: normal normal 100 40px/30px Roboto;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 0.9;
}
.skin-analysis-loading-percent {
  position: absolute;
  bottom: 46px;
  right: 12px;
  transform: translate(0%, 0%);
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  width: 26px;
  height: 26px;
  font: normal normal normal 20px/28px Roboto;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.skin-analysis-loading-trivia-container-wrapper {
  height: 160px;
  width: 80%;
  min-width: 343px;
  position: absolute;
  top: calc(50% + 180px);
  left: 50%;
  transform: translate(-50%, -50%);
}

.skin-analysis-loading-trivia-container {
  height: 100%;
  width: 100%;
  position: relative;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 12px;
}

.skin-analysis-trivia-title {
  width: 100px;
  height: 26px;
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translate(-50%, 0);

  text-align: center;
  font: normal normal normal 18px/26px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.skin-analysis-trivia-content {
  position: absolute;
  top: 58px;
  left: 24px;
  right: 24px;

  text-align: left;
  font: normal normal normal 18px/26px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
}
</style>
